import React, { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";
import Seo from "@/components/site/Seo";

export default function RequestQuote() {
  const [form, setForm] = useState({ customer_name: "", company_name: "", phone: "", whatsapp: "", email: "", requirements: "", preferred_contact: "phone" });
  const [done, setDone] = useState(null);
  const submit = async () => {
    if (!form.customer_name || !form.phone) { toast.error("Name and phone required"); return; }
    try {
      const { data } = await api.post("/enquiries", { ...form, email: form.email || null, items: [{ product_name: "General bulk / quote request", quantity: 1, notes: form.requirements }] });
      setDone(data.enquiry_id);
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };
  if (done) return (
    <div className="container-x py-16 text-center max-w-2xl mx-auto">
      <CheckCircle2 className="w-20 h-20 text-emerald-500 mx-auto"/>
      <h1 className="font-heading font-extrabold text-3xl mt-4">Quote Request Received</h1>
      <p className="text-slate-600 mt-2">Reference: <span className="font-mono text-[#EA580C]">{done}</span></p>
    </div>
  );
  return (
    <div className="bg-[#F8FAFC] min-h-screen">
      <Seo page="request-quote"/>
      <div className="bg-[#0F172A] text-white py-10">
        <div className="container-x">
          <h1 className="font-heading font-extrabold text-3xl sm:text-4xl">Request a Quote</h1>
          <p className="text-slate-300 mt-1">Share your requirement. We'll check availability and share a wholesale quote.</p>
        </div>
      </div>
      <div className="container-x py-8 max-w-2xl">
        <div className="bg-white border border-[#E2E8F0] rounded-md p-6 space-y-3">
          <div><Label>Name *</Label><Input value={form.customer_name} onChange={e=>setForm(f=>({...f, customer_name: e.target.value}))} data-testid="quote-name"/></div>
          <div><Label>Company</Label><Input value={form.company_name} onChange={e=>setForm(f=>({...f, company_name: e.target.value}))}/></div>
          <div className="grid sm:grid-cols-2 gap-3">
            <div><Label>Phone *</Label><Input value={form.phone} onChange={e=>setForm(f=>({...f, phone: e.target.value}))} data-testid="quote-phone"/></div>
            <div><Label>WhatsApp</Label><Input value={form.whatsapp} onChange={e=>setForm(f=>({...f, whatsapp: e.target.value}))}/></div>
          </div>
          <div><Label>Email</Label><Input type="email" value={form.email} onChange={e=>setForm(f=>({...f, email: e.target.value}))}/></div>
          <div><Label>Product / Requirement Details</Label><Textarea rows={5} value={form.requirements} onChange={e=>setForm(f=>({...f, requirements: e.target.value}))} data-testid="quote-requirements"/></div>
          <Button className="btn-orange w-full" onClick={submit} data-testid="quote-submit">Request Quote</Button>
        </div>
      </div>
    </div>
  );
}
